<!-- <a *ngIf="cyd.ceuDueOn" routerLink="/practitioner/credentials-maintenance/default" class="total-ceus-due__link">Document my CEUs</a> -->
<!-- <div *ngIf="cyd.ceuDueOn">
  <button type="button" routerLink="/practitioner/credentials-maintenance/default" class="button button--alt">Enter my CEUs</button>
</div> -->
<button
    type="button"
    class="button button--alt button--small button-list__item"
    routerLink="/assessment/getemail/{{personId}}"
>
    Send my CMP Assessment Report
</button>

<div class="graph">
  <details>
    <summary>
      <strong>Check your CMP progress</strong>
    </summary>
    <div class="total-ceus-due__score">
      CEUs likely due on {{cyd.ceuDueOn | amDateFormat: 'MM/DD/YYYY'}}
      <h2 class="total-ceus-due__subheading"></h2>
      <div class="progress-chart total-ceus-due__progress-chart">
        <canvas
          baseChart
          #progressChart
          [datasets]="chartData.datasets"
          [labels]="chartLabels"
          [options]="chartOptions"
          [colors]="colors"
          [legend]="false"
          [chartType]="doughnutChartType"
        ></canvas>
        <div class="progress-chart__label">
          <span class="progress-chart__label-text">{{cyd.ceuDueTotalCount}}</span>
        </div>
      </div>
    </div>
  </details>
</div>

<div style="border-top:3px solid #e9eaeb; padding-top: 10px; position: relative;">
    <details>
        <summary>
            <strong>Check your CRCE progress</strong>
        </summary>
        <div *ngIf="!credential || !credential.name">
            You must select a credential type to see the corresponding CRCE status.
        </div>
        <div *ngIf="credential && credential.name">
            {{credential.crceYear}} {{credential.name}} Assessment Progress
            <progress
                max="100"
                value={{crcePercentage}}
                class="node-js"
            >
                <!-- Browsers that support HTML5 progress element will ignore the html inside `progress` element. Whereas older browsers will ignore the `progress` element 
            and instead render the html inside it. -->
                <div class="progress-bar">
                    <span style="width: crcePercentage">{{crcePercentage | number : '1.0-0'}}%</span>
                </div>
            </progress>
            {{credential.questionAnsweredCountForCurrentYearCRCE}} out of {{credential.questionCountForCurrentYearCRCE}} questions completed
            <br>
            90% required to earn CRCE
            <br>
            <br>
            {{credential.crcePreviousYear}} {{credential.name}} Assessment Progress
            <div *ngIf="credential.crcePreviousYear">
                <progress
                    max="100"
                    value={{crcePercentagePreviousYear}}
                    class="node-js"
                >
                    <!-- Browsers that support HTML5 progress element will ignore the html inside `progress` element. Whereas older browsers will ignore the `progress` element 
              and instead render the html inside it. -->
                    <div class="progress-bar">
                        <span style="width: crcePercentagePreviousYear">
                            {{crcePercentagePreviousYear | number : '1.0-0'}}%
                        </span>
                    </div>
                </progress>
                {{credential.questionAnsweredCountForPreviousYearCRCE}} out of {{credential.questionCountForPreviousYearCRCE}} questions completed
                <br>
                90% required to earn CRCE
            </div>
        </div>
    </details>
</div>

<script>
    var coll = document.getElementsByClassName("collapsible");
  var i;
  
  for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      if (content.style.display === "block") {
        content.style.display = "none";
      } else {
        content.style.display = "block";
      }
    });
  }
</script>
